module.exports = __webpack_public_path__ + "static/media/b.a0493210.png";